import ApiService from "@/api/ApiService";
import { Add, Loop } from "@mui/icons-material";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import AddExternalDialog, { NewExternalOrder } from "./AddNewExternalDialog";
import dayjs from "dayjs";

const initialExternalOrder: () => NewExternalOrder = () => ({
  id: 0,
  plant: null,
  position: null,
  amount: 0,
  project: "",
  logistics: "",
  firstLoad: "",
  number: "",
  customer: null,
  date: dayjs().format("YYYY-MM-DD"),
});

export function DirectNewExternalMaterialBooking({ allowedPlant }: { allowedPlant: number }) {
  const queryClient = useQueryClient();

  const saveMutation = useMutation<NewExternalOrder, AxiosResponse, NewExternalOrder>({
    mutationFn: ApiService.createEntity("externalMaterialOrder", true, { v: "external" }),
    onSuccess: (answer) => {
      queryClient.invalidateQueries({ queryKey: ["getMaterialCalendar"] });
    },
  });

  const loading = saveMutation.isPending;

  return true ? (
    <AddExternalDialog
      save={function (order: NewExternalOrder): void {
        saveMutation.mutate({ ...order });
      }}
      OpenButton={({ onClick }) => (
        <div className="directbookingButton external" onClick={!loading ? onClick : () => {}}>
          {loading ? <Loop fontSize="inherit" /> : <Add fontSize="inherit" />}
          <div className="dibutext">hinzufügen</div>
        </div>
      )}
      allowedPlant={allowedPlant}
      initialState={{
        ...initialExternalOrder(),
      }}
    />
  ) : null;
}
